/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" -- Legacy code: do not use as an example. */
import isPropValid from '@emotion/is-prop-valid';
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Product } from '@toucan/client/global/product';

import { styles } from './product-card-sku.styles';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type SkuProps = {
    /**
     * If a loading state should be displayed
     */
    isLoading?: boolean;

    /**
     * The product we are displaying
     */
    product?: Product;

    className?: string;
};

const StyledSku = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const Sku: FunctionComponent<SkuProps> = ({
    isLoading,
    product,
    ...otherProps
}: SkuProps) => {
    const { t } = useTranslation();

    if (!isLoading && !product) {
        return null;
    }

    const { sku } = product || {};

    const renderSkeleton = () => {
        return (
            <Skeleton
                variant={SkeletonVariant.TEXT}
                className="sku"
                data-testid="product-card__sku__skeleton"
            />
        );
    };

    const renderSku = () => {
        return (
            <span className="sku" data-testid="product-card__sku__sku">
                {t('SKU', { context: 'productCard' })}: {sku}
            </span>
        );
    };

    return (
        <StyledSku {...otherProps}>
            {isLoading ? renderSkeleton() : renderSku()}
        </StyledSku>
    );
};
